import React, { useState } from "react";
import api from "../../../../../features/auth/axiosConfig";
import { Product } from "../types/productTypes";
import "react-toastify/dist/ReactToastify.css";
import ConfirmDialog from "../../../../components/genericform/ConfirmDialog";
import { notifyError, notifySuccess } from "src/assets/toastService";

interface Props {
  product: Product;
  onClose: () => void;
  onDelete: () => void;
}

const DeleteProducts: React.FC<Props> = ({ product, onClose, onDelete }) => {
  const [loading, setLoading] = useState(false);

  const deleteProduct = async () => {
    if (!product._id?.$oid) return;

    setLoading(true);
    try {
      await api.delete(`/app/v1/pos/product`, {
        data: { ids: [product._id.$oid] },
      });
      setTimeout(() => {
        onDelete();
        onClose();
        notifySuccess("Product deleted successfully");
      }, 2000);
    } catch (error) {
      console.error("Error deleting product:", error);
      notifyError("Failed to delete product.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ConfirmDialog
        open={true}
        title="Delete Confirmation"
        description={`Are you sure you want to delete the product: "${product.ProductName}"?`}
        confirmLabel="Delete"
        cancelLabel="Cancel"
        isProcessing={loading}
        onConfirm={deleteProduct}
        onCancel={onClose}
      />
    </>
  );
};

export default DeleteProducts;
